import { render, staticRenderFns } from "./ViewMyRequests.vue?vue&type=template&id=97caa742&scoped=true&"
import script from "./ViewMyRequests.vue?vue&type=script&lang=js&"
export * from "./ViewMyRequests.vue?vue&type=script&lang=js&"
import style0 from "./ViewMyRequests.vue?vue&type=style&index=0&id=97caa742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97caa742",
  null
  
)

export default component.exports